import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { IconComponent } from '@zero/shared/ui-web-design-system';

@Component({
  selector: 'web-components-back-link',
  standalone: true,
  imports: [TranslocoPipe, IconComponent],
  templateUrl: './back-link.component.html',
})
export class BackLinkComponent {
  public location = inject(Location);
}
